<template>
    <div>
        <div class="row">
            <div class="col-md-8">
                <b-form-input id="q" placeholder="Search" v-model="q" @keyup.enter="search"></b-form-input>
            </div>
            <div class="col-md-2">
                <b-form-select :options="types" v-model="type"></b-form-select>
            </div>
            <div class="col-md-2">
                <b-button block @click="search">Search</b-button>
            </div>
        </div>
        <div v-if="search_results" class="mt-3">
            <b-card>
                <template #header>
                    <h6 class="mb-0">Search Results for "{{ q }}" ({{ search_results.length }})</h6>
                </template>
                <b-list-group flush>
                    <b-list-group-item v-for="result in search_results" :key="result.id">
                        <a :href="result.url"><font-awesome-icon :icon="result.icon" /> {{ result.title }}</a>
                    </b-list-group-item>
                </b-list-group>
            </b-card>
        </div>
    </div>
</template>

<script>

import FormDataService from "@/services/FormDataService.js";
import SearchDataService from "@/services/SearchDataService";
import ReferenceDataService from "@/services/ReferenceDataService";
export default {
    name: "SearchPage",
    data() {
        return {
            q: "",
            type: null,
            types: [
                {
                    text: 'Any',
                    value: null
                },
                {
                    text: 'Policy',
                    value: 'policy'
                }
            ],
            search_results: [],
            icons: {},
        };
    },
    created() {
        this.q = this.$route.query.q;        

        if (this.$route.query.type !== undefined) {

            this.type = this.$route.query.type;
        }

        this.icons = ReferenceDataService.aspect_icons();

        FormDataService.list().then((res) => {
            const forms = res?.data || res;
            if (forms && Array.isArray(forms)) {
                forms.forEach(element => {
                    this.types.push({
                        text: element.name,
                        value: element.id
                    })
                });
            }
        }).catch(() => {
            console.error('Failed to load form types for search');
        });
    },
    mounted() {

        this.search();

    },
    methods: {
        search() {
            this.search_results = [];

            if (!this.q || this.q.length < 2) {
                return;
            }

            SearchDataService.filtered(this.q, this.type).then((res) => {
                if (res && res.data && Array.isArray(res.data)) {
                    res.data.forEach((result) => {
                        let url = result.url;
                        url = url.replace("aspect/view", "aspect");
                        url = url.replace("policies/view", "policy");

                        this.search_results.push({
                            title: result.title,
                            url: url,
                            icon: this.icons[result.icon],
                            type: result.type
                        });
                    });
                }
            }).catch(() => {
                this.search_results = [];
            });
        }
    }
};
</script>